import { legacy_createStore as createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { persistStore, persistReducer, createTransform } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { rootReducer } from "./reducers/root-reducers";

const globalStateTransform = createTransform(
  (inboundState) => {
    const isFirstPersist = !localStorage.getItem("hasPersistedOnce");

    if (isFirstPersist) {
      localStorage.setItem("hasPersistedOnce", "true");

      const {
        rowStatus,
        isModalOpen,
        modalData,
        departmentsData,
        usersData,
        rolesData,
        groupingData,
        articlesData,
        newsData,
        projectsData,
        faqData,
        ...rest
      }: any = inboundState;
      console.log(
        rowStatus,
        isModalOpen,
        modalData,
        departmentsData,
        usersData,
        rolesData,
        groupingData,
        articlesData,
        newsData,
        projectsData,
        faqData
      );
      return {
        ...rest,
        rowStatus: { status: false, id: "" },
        isModalOpen: false,
        modalData: {
          title: "Notification",
          message: "are you sure??",
          buttonText: "confirm",
        },
        departmentsData: [],
        usersData: [],
        rolesData: [],
        groupingData: [],
        articlesData: [],
        newsData: [],
        projectsData: [],
        faqData: [],
      };
    }

    // از بار دوم به بعد، هیچ تغییری نده
    return inboundState;
  },
  (outboundState) => outboundState,
  { whitelist: ["globalState"] }
);

const persistConfig = {
  key: "root",
  storage,
  transforms: [globalStateTransform],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
export const store = createStore(persistedReducer, applyMiddleware(thunk));
export const persistor = persistStore(store);
export type { RootState } from "./reducers/root-reducers";
